<template>
	<sa-page-layout>
		<template slot="toolbar-title"> QR-Code per Associazione App </template>
		<template slot="table-body">
			<div class="page-wrapper">
				<div class="qr-card">
					<h3>Configurazione Nurity</h3>
					<p>Inquadra il codice con la tua app</p>
					<div class="qr-code-container">
						<qrcode-vue :value="qrValue" :size="200" level="H"></qrcode-vue>
					</div>
				</div>
			</div>
		</template>
	</sa-page-layout>
</template>

<script>
import Vue from "vue";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import QrcodeVue from "qrcode.vue";

export default {
	components: { SaPageLayout, QrcodeVue },
	data() {
		return {
			config: {
				baseUrl: Vue.prototype.appConfig.appBaseUrl.trim(),
				loginUrl: Vue.prototype.appConfig.appLoginUrl.trim(),
				name: Vue.prototype.appConfig.appName,
				theme: "nurity",
				authorization: "",
			},
		};
	},
	computed: {
		qrValue() {
			console.log(this.config);
			console.log(Vue);
			return JSON.stringify(this.config);
		},
	},
	methods: {
		printQR() {
			window.print();
		},
	},
};
</script>

<style scoped>
/* Centra il contenuto nella pagina */
.page-wrapper {
	display: flex;
	justify-content: center; /* Centra orizzontalmente */
	align-items: center; /* Centra verticalmente */
	min-height: 100vh; /* Occupa tutta l'altezza dello schermo */
	background-color: #f5f7fa; /* Un grigio leggero di sfondo */
	margin: 0;
}

/* Una card elegante per contenere il QR */
.qr-card {
	background: white;
	padding: 2rem;
	border-radius: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
	text-align: center;
	max-width: 350px;
	width: 100%;
}

h3 {
	margin-bottom: 0.5rem;
	color: #333;
	font-family: sans-serif;
}

p {
	color: #666;
	font-size: 0.9rem;
	margin-bottom: 1.5rem;
}

.qr-code-container {
	display: inline-block;
	padding: 10px;
	border: 1px solid #eee;
	border-radius: 8px;
	background: #fff;
}

.btn-secondary {
	margin-top: 1.5rem;
	padding: 10px 20px;
	border: none;
	background-color: #4a90e2;
	color: white;
	border-radius: 5px;
	cursor: pointer;
	transition: background 0.3s;
}

.btn-secondary:hover {
	background-color: #357abd;
}

/* Nasconde il pulsante e lo sfondo durante la stampa */
@media print {
	.btn-secondary,
	.page-wrapper {
		background: white;
	}
	.btn-secondary {
		display: none;
	}
}
</style>
